'use strict';

const DataTypes = require('../../../enums/data-types');

const fixedFields = [
  {
    mongoField: 'furnitureCategory1Key',
    type: DataTypes.alphanumeric,
    // The comparison function uses Lodash _.lowerCase which converts string, as space separated words, to lower case.
    // 'Product Key' === 'product key'  |  'productKey' === 'product key'  |  '--Product-Key--' === 'product key'
    aliases: 'csvAliases.furnitureArchetype.furnitureCategory1Key',
    translationKey: 'mongoFields.furnitureCategory1Key',
    required: true,
  },
  {
    mongoField: 'name',
    type: DataTypes.str,
    aliases: 'csvAliases.furnitureArchetype.name',
    translationKey: 'mongoFields.furnitureArchetypeName',
    required: true,
  },
  {
    mongoField: 'size',
    type: DataTypes.number,
    aliases: 'csvAliases.furnitureArchetype.size',
    translationKey: 'mongoFields.size',
    required: true,
  },
  {
    mongoField: 'description',
    type: DataTypes.str,
    aliases: 'csvAliases.furnitureArchetype.description',
    translationKey: 'mongoFields.description',
    required: false,
  },
];

module.exports = {
  fixedFields,
};
